<template>
  <div class="completed-homework-detail" v-bitmap="getHomeworkDetailResult">
    <div
      class="homework-content-container"
      :class="{ isShow: isHomeworkDetailShow }"
    >
      <div class="homework-title">
        {{ homeworkDetail ? homeworkDetail.title : "" }}
      </div>
      <div class="homework-content">
        {{ homeworkDetail ? homeworkDetail.content : "" }}
      </div>
    </div>
    <div class="homework-dialog-bottom-main-container">
      <div
        class="student-submitted-homework-detail"
        :class="{
          isShow: isHomeworkDetailShow,
          correctComplete: isCorrectComplete,
        }"
      >
        <!-- <div class="star-homework-identification" v-if="isStarHomework">
          <img
            class="star-homework-identification-image"
            src="https://mp-e5e89746-ca94-4f60-a11b-04e385fa7ba4.cdn.bspapp.com/cloudstorage/5e676ac1-0f19-43ff-96dc-6b51b88dbb06.png"
          />
        </div> -->
        <div class="student-submitted-title">
          <div class="title">
            {{ homeworkDetail ? homeworkDetail.studentName : "" }}提交的作业详情
          </div>
        </div>
        <div class="student-submitted-homework-detail-content-container">
          <div class="student-infto-container">
            <div class="student-avatar">
              <el-image
                :src="homeworkDetail ? homeworkDetail.stuHeadPortrait : ''"
                fit="cover"
              >
                <div
                  slot="error"
                  class="image-slot"
                  style="
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f5f7fa;
                    color: #c0c4cc;
                    font-size: 12px;
                  "
                >
                  <div>无法显示</div>
                </div></el-image
              >
            </div>
            <div class="student-info">
              <div class="student-name">
                {{ homeworkDetail ? homeworkDetail.studentName : "" }}
              </div>
              <div class="student-number">
                {{ homeworkDetail ? homeworkDetail.studentNumber : "" }}
              </div>
              <div class="star-homework-button-wrapper">
                <button
                  class="star-homework-button"
                  @click="setToStarHomework"
                  v-if="isCorrectComplete"
                  :disabled="isPublisher"
                  :class="{ disabled: isPublisher }"
                >
                  <i
                    class="iconfont icon-star-fill star-icon"
                    v-if="isStarHomework"
                  />
                  <i class="iconfont icon-star-hollow star-icon" v-else />
                  {{ isStarHomework ? "取消明星作业" : "升级为明星作业" }}
                </button>
              </div>
            </div>
          </div>
          <div class="homework-enclosure-container">
            <div class="homework-enclosure-title">作业附件</div>
            <div class="homework-enclosure-list">
              <div
                class="homework-enclosure-item"
                v-for="(item, index) in enclosureList"
                :key="index"
              >
                <el-image
                  :src="item"
                  fit="cover"
                  :preview-src-list="enclosureList"
                >
                  <div
                    slot="error"
                    class="image-slot"
                    style="
                      width: 100%;
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: #f5f7fa;
                      color: #c0c4cc;
                      font-size: 12px;
                    "
                  >
                    <div>无法显示</div>
                  </div></el-image
                >
              </div>
              <div class="no-file-tips" v-if="enclosureList.length == 0">
                无作业附件
              </div>
            </div>
          </div>
          <div class="homework-text-container">
            <div class="homework-text-title">提交内容</div>
            <div class="homework-text-main">
              {{ homeworkDetail ? homeworkDetail.remark : "" }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="teacher-correct-detail"
        :class="{ isShow: isHomeworkDetailShow }"
      >
        <div class="teacher-correct-title">科任老师批改区域</div>
        <div class="teacher-correct-detail-container">
          <div class="teacher-correct-item-container">
            <div class="teacher-correct-item-title">发布与批改该作业的老师</div>
            <div class="teacher-correct-item-inner-container">
              <div class="teacher-avatar">
                <el-image
                  :src="homeworkDetail ? homeworkDetail.teaHeadPortrait : ''"
                  fit="cover"
                >
                  <div
                    slot="error"
                    class="image-slot"
                    style="
                      width: 100%;
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: #f5f7fa;
                      color: #c0c4cc;
                      font-size: 12px;
                    "
                  >
                    <div>无法显示</div>
                  </div></el-image
                >
              </div>
              <div class="teacher-info">
                <div class="teacher-name">
                  {{ homeworkDetail ? homeworkDetail.teacherName : "" }}
                </div>
                <div class="teacher-number">
                  {{ homeworkDetail ? homeworkDetail.teacherNumber : "" }}
                </div>
              </div>
            </div>
          </div>
          <div class="teacher-correct-item-container">
            <div class="teacher-correct-item-title">作业评分</div>
            <div class="teacher-correct-item-inner-container">
              <el-rate v-model="homeworkRate" :disabled="isPublisher"></el-rate>
            </div>
          </div>
          <div class="teacher-correct-item-container">
            <div class="teacher-correct-item-title">作业评语</div>
            <div class="teacher-correct-item-inner-container">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 8 }"
                placeholder="请输入内容"
                v-model="homeworkComment"
                :disabled="isPublisher"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </div>
          </div>
          <div class="submit-button-container">
            <button
              class="submit-button"
              @click="submitCorrect"
              :disabled="isPublisher"
              :class="{ disabled: isPublisher }"
            >
              提交批改
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getHomeworkDetailResult: "nullData",
      isHomeworkDetailShow: false,
      homeworkRate: 0,
      homeworkComment: "",
      isCorrectComplete: false,
      isStarHomework: false,
      enclosureList: [],
      homeworkDetail: null,
    };
  },
  props: {
    currentCompletedHomeworkData: {
      type: Object,
    },
  },
  computed: {
    isPublisher() {
      if (
        this.homeworkDetail &&
        this.homeworkDetail.teacherId == this.user.id
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    // console.log(this.currentCompletedHomeworkData);
    this.getHomeworkDetail();
    
  },
  methods: {
    getHomeworkDetail() {
      this.getHomeworkDetailResult = "loading";
      this.get(this.$url.selectSubmitHomeworkDesc, {
        id: this.currentCompletedHomeworkData.id,
      })
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            this.getHomeworkDetailResult = "error";
            return this.$message.error("获取作业详情失败");
          }
          this.getHomeworkDetailResult = "success";
          this.isHomeworkDetailShow = true;
          this.homeworkDetail = res.data;
          if (this.homeworkDetail.imgList) {
            this.enclosureList = this.homeworkDetail.imgList.split(",");
          }
          this.homeworkRate = this.homeworkDetail.giveMark;
          this.homeworkComment = this.homeworkDetail.comment
            ? this.homeworkDetail.comment
            : "";
          this.isStarHomework = this.homeworkDetail.startHomework == "1";
          this.isCorrectComplete = this.homeworkDetail.status == "3";
        })
        .catch((err) => {
          this.getHomeworkDetailResult = "error";
          this.$message.error("获取作业详情失败");
        });
    },
    submitCorrect() {
      this.post(this.$url.updateSubmitHomework, {
        id: this.homeworkDetail.id,
        status: "3",
        giveMark: this.homeworkRate,
        comment: this.homeworkComment,
        updateBy: this.user.id,
      })
        .then((res) => {
          if (res.code != 200) {
            return this.$message.error("提交作业批改失败");
          }
          this.$message.success("批改成功");
          this.isCorrectComplete = true;
          this.$emit("refresh"); // 刷新
        })
        .catch((err) => {
          this.$message.error("修改失败");
        });
    },
    setToStarHomework() {
      this.post(this.$url.updateSubmitHomework, {
        id: this.homeworkDetail.id,
        status: "3",
        startHomework: !this.isStarHomework ? 1 : 0,
        updateBy: this.user.id,
      })
        .then((res) => {
          if (res.code != 200) {
            return this.$message.error("修改失败");
          }
          this.$message.success("修改成功");
          this.isStarHomework = !this.isStarHomework;
        })
        .catch((err) => {
          this.$message.error("修改失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./completedHomeworkDetail.scss";
</style>